<template>
  <page-error
    class="v-error404"
    :code="404"
    :message="$t('The page you are looking for cannot be found.')"
    :title="$t('Page not found')"
  />
</template>

<script>
  import PageError from '@/common/components/PageError.vue';

  export default {
    name: 'Error404',
    components: {
      PageError
    }
  };
</script>
